import {
  ArrowLeftIcon,
  Button,
  IconButton,
  Lead,
  Modal,
  Paper,
  Slot,
  Text,
  TimeMOutlineIcon,
  Typography,
  useMarginRef,
} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {ReactElement} from 'react'

import type {PickupPoint} from '../../types'
import {isYandexMarketPickupPoint} from '../../utils'
import * as classes from './DetailShortModal.classes'

type Props = {
  pickupPoint: PickupPoint
  onBackButtonClick: VoidFunction
  onPickupPointChange(pickupPoint: PickupPoint): void
}

export function DetailShortModal(props: Props): ReactElement {
  const i18n = useI18n()
  const {pickupPoint, onBackButtonClick: closeHandler, onPickupPointChange: changeHandler} = props
  const withExtraBar = isYandexMarketPickupPoint(pickupPoint)
  const ref = useMarginRef<HTMLDivElement>(el => ({
    bottom: el.offsetHeight,
  }))

  function clickHandler() {
    changeHandler(pickupPoint)
    closeHandler()
  }

  const children = (
    <Paper flexDirection="column">
      <Slot className={classes.slot} size="l">
        <Text
          // @ts-expect-error Property 'Component' does not exist on type...
          Component={Typography}
          thickness="medium"
          variant="body1"
        >
          {pickupPoint.name}
        </Text>
      </Slot>
      {pickupPoint.schedule && (
        <Slot className={classes.slot} py="xs" size="m">
          <Lead>
            <TimeMOutlineIcon />
          </Lead>
          <Text>
            <Typography variant="body2">{i18n('ndd.pickup_points.schedule', 'График работы')}</Typography>
            <Typography color="minor" variant="caption1">
              {pickupPoint.schedule.join('\n')}
            </Typography>
          </Text>
        </Slot>
      )}
      <Modal.Footer.Controls pb="s" pl="s" pr="s">
        <Button onPress={clickHandler} variant="action" fullWidth>
          {i18n('bdui.pickup_points.source.send', 'Отправить  отсюда')}
        </Button>
      </Modal.Footer.Controls>
    </Paper>
  )

  return (
    <div ref={ref} className={classes.body}>
      <IconButton className={classes.closeButton} onPress={closeHandler} shape="circle" variant="floating">
        <ArrowLeftIcon />
      </IconButton>
      {withExtraBar ? (
        <Paper className={classes.extraBar} flexDirection="column">
          <Typography justifyContent="center" p="s" variant="caption1">
            {i18n('bdui.pickup_points.point-slot.isMarket', 'Пункт Яндекс Маркета')}
          </Typography>
          {children}
        </Paper>
      ) : (
        children
      )}
    </div>
  )
}
